import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var UnderscorePipe = (function () {
    function UnderscorePipe() {
    }
    UnderscorePipe.prototype.transform = function (text, chars) {
        if (chars === void 0) { chars = '\\s'; }
        return isString(text)
            ? text.trim()
                .replace(/\s+/g, '')
                .replace(/[A-Z]/g, function (c, k) {
                return k ? "_" + c.toLowerCase() : c.toLowerCase();
            })
            : text;
    };
    return UnderscorePipe;
}());
export { UnderscorePipe };
UnderscorePipe.decorators = [
    { type: Pipe, args: [{ name: 'underscore' },] },
];
/** @nocollapse */
UnderscorePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=underscore.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/underscore.js
// module id = 273
// module chunks = 4